module.exports = __webpack_public_path__ + "static/media/troyes-champagne-lunchtime-1600x1067.8dfeddcd.jpg";